import { ROUTES } from '@/routes';
import { ChevronLeftIcon } from 'lucide-react';
import { Link } from 'react-router-dom';
import { LayoutOrderContainer } from './orders/_layouts/LayoutOrderContainer';
import { InfoContainer } from '@/components/update-info/info-container';

export const UpdateInfoPage = () => {
  return (
    <LayoutOrderContainer className="space-y-[26px] px-[60px] py-10">
      <div>
        <Link to={ROUTES.more} className="flex items-center gap-3">
          <ChevronLeftIcon width={32} height={32} className="text-gr-800" />
          <span className="text-gr-900 Title2S24">뒤로가기</span>
        </Link>
      </div>
      <div className="flex items-center justify-center">
        <InfoContainer />
      </div>
    </LayoutOrderContainer>
  );
};
